import { jwtDecode } from "jwt-decode";

interface AccessTokenClaims {
	exp?: number;
	unique_name?: string;
}

const MILLISECONDS_PER_SECOND = 1000;
const EXPIRY_MARGIN_MILLISECONDS = 5 * 60 * MILLISECONDS_PER_SECOND;

const decodeAccessToken = (token: string): AccessTokenClaims | null => {
	try {
		return jwtDecode<AccessTokenClaims>(token);
	} catch {
		return null;
	}
};

export const getTokenUserName = (token: string): string => decodeAccessToken(token)?.unique_name ?? "";

export const isTokenExpired = (token: string, now = Date.now()): boolean => {
	const expiresAt = decodeAccessToken(token)?.exp;
	return !expiresAt || expiresAt * MILLISECONDS_PER_SECOND - EXPIRY_MARGIN_MILLISECONDS <= now;
};
